import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import crane from '@public/images/logos/crane.png'
import n26 from '@public/images/logos/n26.png'
import truelayer from '@public/images/logos/truelayer.png'
import voi from '@public/images/logos/voi.png'
import yapily from '@public/images/logos/yapily.png'

import LogosGrid from '@/components/LogosGrid'
import useDevice from '@/hooks/useDevice'

const logos = [
    {
        name: 'Crane',
        img: crane,
        width: 97.75,
        height: 32,
    },
    {
        name: 'n26',
        img: n26,
        width: 43.8,
        height: 30,
    },
    {
        name: 'truelayer',
        img: truelayer,
        width: 140.52,
        height: 24,
    },
    {
        name: 'voi',
        img: voi,
        width: 58,
        height: 28,
    },
    {
        name: 'yapily',
        img: yapily,
        width: 85.9,
        height: 19,
    },
]

const BackedByLogos = () => {
    const { smScreen, mdScreen } = useDevice()
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: smScreen ? 'flex-start' : 'center',
                gap: smScreen ? 7 : 6,
                flexDirection: 'column',
            }}
        >
            <Text
                variant={mdScreen ? 'h5' : 'h4'}
                sx={{
                    textAlign: smScreen ? 'left' : 'center',
                }}
            >
                Backed by leading venture capitalists and entrepreneurs
            </Text>
            <Box sx={{ width: '100%' }}>
                <LogosGrid
                    sx={{ ...(!smScreen && { height: '120px', lineHeight: '120px' }) }}
                    logos={logos}
                />
            </Box>
        </Box>
    )
}

export default BackedByLogos
